import * as React from 'react';

const ClipboardIcon = ({color = 'black', size = 24}) => (
    <svg
        width={size}
        height={size}
        viewBox="1 1 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14 7c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C12.398 4 11.932 4 11 4H8c-1.886 0-2.828 0-3.414.586S4 6.114 4 8v3c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C5.602 14 6.068 14 7 14"
            stroke={color}
            strokeWidth={2}
        />
        <rect
            x={10}
            y={10}
            width={10}
            height={10}
            rx={2}
            stroke={color}
            strokeWidth={2}
        />
    </svg>
);
export default ClipboardIcon;
